import createReducer from 'utils/createReducer';

// Initial State
const INIT_STATE = {
  plainData: new Map(),
  groupedData: {},
  groupedTotals: {},
  nextLink: '',
  loading: true,
  mounted: false,
  visible: true,
  loadingNextPage: false,
};

// Actions
const SET_LOADING = 'shipper-orders/SET_LOADING';
const SET_PLAIN_DATA = 'shipper-orders/SET_PLAIN_DATA';
const SET_PLAIN_AND_GROUPED_DATA = 'shipper-orders/SET_PLAIN_AND_GROUPED_DATA';
const SET_GROUPED_DATA = 'shipper-orders/SET_GROUPED_DATA';

const SET_NEXT_LINK = 'shipper-orders/SET_NEXT_LINK';
const SET_LAST_PAGE = 'shipper-orders/SET_LAST_PAGE';
const SET_TOTALS = 'shipper-orders/SET_TOTALS';
const SET_MOUNTED = 'shipper-orders/SET_MOUNTED';
const SET_VISIBLE = 'shipper-orders/SET_VISIBLE';
const SET_LOADING_NEXT_PAGE = 'shipper-orders/SET_LOADING_NEXT_PAGE';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_LOADING](state, action) {
    return {
      ...state,
      loading: action,
    };
  },
  [SET_MOUNTED](state, mounted) {
    return {
      ...state,
      mounted,
    };
  },
  [SET_PLAIN_AND_GROUPED_DATA](state, { plainData, groupedData }) {
    return {
      ...state,
      plainData,
      groupedData,
    };
  },
  [SET_PLAIN_DATA](state, data) {
    return {
      ...state,
      plainData: data,
    };
  },
  [SET_GROUPED_DATA](state, data) {
    return {
      ...state,
      groupedData: data,
    };
  },
  [SET_NEXT_LINK](state, nextLink) {
    return {
      ...state,
      nextLink,
    };
  },
  [SET_LAST_PAGE](state, lastPage) {
    return {
      ...state,
      lastPage,
    };
  },
  [SET_TOTALS](state, totals) {
    return {
      ...state,
      groupedTotals: totals,
    };
  },
  [SET_VISIBLE](state, visible) {
    return {
      ...state,
      visible,
    };
  },
  [SET_LOADING_NEXT_PAGE](state, loadingNextPage) {
    return {
      ...state,
      loadingNextPage,
    };
  },
});

// Action creators

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});

export const setPlainAndGroupedData = ({ plainData, groupedData }) => ({
  type: SET_PLAIN_AND_GROUPED_DATA,
  payload: { plainData, groupedData },
});

export const setPlainData = (data) => ({
  type: SET_PLAIN_DATA,
  payload: data,
});

export const setGroupedData = (data) => ({
  type: SET_GROUPED_DATA,
  payload: data,
});

export const setNextLink = (nextLink) => ({
  type: SET_NEXT_LINK,
  payload: nextLink,
});

export const setLastPage = (lastPage) => ({
  type: SET_LAST_PAGE,
  payload: lastPage,
});

export const setTotals = (totals) => ({
  type: SET_TOTALS,
  payload: totals,
});

export const setMounted = (mounted) => ({
  type: SET_MOUNTED,
  payload: mounted,
});

export const setVisible = (visible) => ({
  type: SET_VISIBLE,
  payload: visible,
});

export const setLoadingNextPage = (loadingNextPage) => ({
  type: SET_LOADING_NEXT_PAGE,
  payload: loadingNextPage,
});
